// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".6c0c7db3ac612ae34e0f7cfbe6eddee568439fb6.chunk.bundle.js";
};